// ============================================
// СЛАЙДЕР ПРЕИМУЩЕСТВ (ADVANTAGES SLIDER)
// ============================================
(function() {
  let advantagesGrid = null;
  let containerAdvange = null;
  let currentAdvantageIndex = 0;
  let isAdvantageTransitioning = false;
  let isAdvantageAnimating = false;
  const advantageItemGap = 20; // отступ между элементами (gap из CSS)

  // Функция для получения ширины элемента
  function getAdvantageItemWidth() {
    if (window.innerWidth <= 768) {
      return 318; // ширина для 768px из CSS
    }
    return 318;
  }

  // Функция для получения шага переключения
  function getAdvantageItemStep() {
    return getAdvantageItemWidth() + advantageItemGap;
  }

  // Функция для получения времени transition
  function getAdvantageTransitionDuration() {
    return window.innerWidth >= 1024 ? '0.2s' : '0.4s';
  }

  // Функция для получения времени transition в миллисекундах
  function getAdvantageTransitionDurationMs() {
    return window.innerWidth >= 1024 ? 200 : 400;
  }

  // Функция для получения реальных элементов (без клонов)
  function getRealAdvantageItems() {
    if (!advantagesGrid) return [];
    const allItems = advantagesGrid.querySelectorAll('.advantage_card');
    return Array.from(allItems).filter(item => !item.classList.contains('advantage-card-clone'));
  }

  // Функция для клонирования элементов для бесконечной карусели
  function cloneAdvantageItems() {
    if (!advantagesGrid) return;
    
    // Удаляем старые клоны
    const oldClones = advantagesGrid.querySelectorAll('.advantage-card-clone');
    oldClones.forEach(clone => clone.remove());

    if (window.innerWidth > 768) return;

    const realItems = getRealAdvantageItems();
    if (realItems.length === 0) return;

    // Клонируем все элементы и добавляем перед первым (для бесконечной прокрутки назад)
    const fragmentBefore = document.createDocumentFragment();
    realItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.classList.add('advantage-card-clone');
      fragmentBefore.appendChild(clone);
    });
    advantagesGrid.insertBefore(fragmentBefore, realItems[0]);

    // Клонируем все элементы и добавляем после последнего (для бесконечной прокрутки вперед)
    realItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.classList.add('advantage-card-clone');
      advantagesGrid.appendChild(clone);
    });
  }

  // Функция для обновления позиции слайдера
  function updateAdvantagesSlider() {
    if (!advantagesGrid || !containerAdvange || window.innerWidth > 768) return;

    const realItems = getRealAdvantageItems();
    if (realItems.length === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentAdvantageIndex < 0) {
      currentAdvantageIndex = 0;
    }
    if (currentAdvantageIndex >= realItems.length) {
      currentAdvantageIndex = realItems.length - 1;
    }

    // Всегда центрируем относительно центра viewport на мобильных
    const centerX = window.innerWidth / 2;
    const containerRect = containerAdvange.getBoundingClientRect();
    const containerLeft = containerRect.left;

    const currentItemWidth = getAdvantageItemWidth();
    const currentItemStep = getAdvantageItemStep();
    const itemCenterX = currentItemWidth / 2;
    // Реальные элементы начинаются после клонов, поэтому индекс в DOM = realItems.length + currentAdvantageIndex
    const realItemIndexInDOM = realItems.length + currentAdvantageIndex;
    const activeItemLeftPosition = realItemIndexInDOM * currentItemStep;
    const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;

    // Всегда центрируем карточку относительно центра экрана
    const translateX = centerX - containerLeft - activeItemCenterPosition;

    // Добавляем плавную анимацию, если не идет переход через клоны
    if (!isAdvantageTransitioning) {
      advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    advantagesGrid.style.transform = `translateX(${translateX}px)`;
  }

  // Функция для получения начальной позиции (с учетом клонов)
  function getInitialAdvantageTranslate() {
    if (!containerAdvange) return 0;
    
    const realItems = getRealAdvantageItems();
    if (realItems.length === 0) return 0;
    
    // Всегда центрируем относительно центра viewport на мобильных
    const centerX = window.innerWidth / 2;
    const containerRect = containerAdvange.getBoundingClientRect();
    const containerLeft = containerRect.left;
    
    const itemWidth = getAdvantageItemWidth();
    const step = getAdvantageItemStep();
    const itemCenterX = itemWidth / 2;
    // Первый реальный элемент находится после всех клонов (realItems.length элементов)
    const firstRealItemIndexInDOM = realItems.length;
    const firstRealItemLeftPosition = firstRealItemIndexInDOM * step;
    const firstRealItemCenterPosition = firstRealItemLeftPosition + itemCenterX;
    
    return centerX - containerLeft - firstRealItemCenterPosition;
  }

  // Переход к следующему элементу
  function goToNextAdvantage() {
    if (isAdvantageTransitioning || isAdvantageAnimating || window.innerWidth > 768) return;
    
    const realItems = getRealAdvantageItems();
    const realItemsCount = realItems.length;
    if (realItemsCount === 0) return;

    if (currentAdvantageIndex < realItemsCount - 1) {
      // Обычный переход на следующий элемент
      isAdvantageAnimating = true;
      currentAdvantageIndex++;
      if (advantagesGrid.style.transition === 'none') {
        advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      }
      updateAdvantagesSlider();
      
      setTimeout(() => {
        isAdvantageAnimating = false;
      }, getAdvantageTransitionDurationMs());
    } else {
      // Переход с последнего на первый через клон
      if (isAdvantageTransitioning || isAdvantageAnimating) return;
      isAdvantageTransitioning = true;
      isAdvantageAnimating = true;
      
      const firstCloneIndex = realItemsCount * 2;
      const currentItemStep = getAdvantageItemStep();
      const currentItemWidth = getAdvantageItemWidth();
      const itemCenterX = currentItemWidth / 2;
      const activeItemLeftPosition = firstCloneIndex * currentItemStep;
      const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
      
      // Всегда центрируем относительно центра viewport
      const viewportCenter = window.innerWidth / 2;
      const containerRect = containerAdvange.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const translateX = viewportCenter - containerLeft - activeItemCenterPosition;
      
      advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      advantagesGrid.style.transform = `translateX(${translateX}px)`;
      
      setTimeout(() => {
        advantagesGrid.style.transition = 'none';
        currentAdvantageIndex = 0;
        updateAdvantagesSlider();
        requestAnimationFrame(() => {
          setTimeout(() => {
            isAdvantageTransitioning = false;
            isAdvantageAnimating = false;
            advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getAdvantageTransitionDurationMs());
    }
  }

  // Переход к предыдущему элементу
  function goToPrevAdvantage() {
    if (isAdvantageTransitioning || isAdvantageAnimating || window.innerWidth > 768) return;
    
    const realItems = getRealAdvantageItems();
    const realItemsCount = realItems.length;
    if (realItemsCount === 0) return;

    if (currentAdvantageIndex > 0) {
      // Обычный переход на предыдущий элемент
      isAdvantageAnimating = true;
      currentAdvantageIndex--;
      if (advantagesGrid.style.transition === 'none') {
        advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      }
      updateAdvantagesSlider();
      
      setTimeout(() => {
        isAdvantageAnimating = false;
      }, getAdvantageTransitionDurationMs());
    } else {
      // Переход с первого на последний через клон
      if (isAdvantageTransitioning || isAdvantageAnimating) return;
      isAdvantageTransitioning = true;
      isAdvantageAnimating = true;
      
      const lastCloneIndex = realItemsCount - 1;
      const currentItemStep = getAdvantageItemStep();
      const currentItemWidth = getAdvantageItemWidth();
      const itemCenterX = currentItemWidth / 2;
      const activeItemLeftPosition = lastCloneIndex * currentItemStep;
      const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
      
      // Всегда центрируем относительно центра viewport
      const viewportCenter = window.innerWidth / 2;
      const containerRect = containerAdvange.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const translateX = viewportCenter - containerLeft - activeItemCenterPosition;
      
      advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      advantagesGrid.style.transform = `translateX(${translateX}px)`;
      
      setTimeout(() => {
        advantagesGrid.style.transition = 'none';
        currentAdvantageIndex = realItemsCount - 1;
        updateAdvantagesSlider();
        requestAnimationFrame(() => {
          setTimeout(() => {
            isAdvantageTransitioning = false;
            isAdvantageAnimating = false;
            advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getAdvantageTransitionDurationMs());
    }
  }

  // Инициализация слайдера
  function initAdvantagesSlider() {
    if (window.innerWidth > 768) {
      // На десктопе очищаем стили слайдера
      if (advantagesGrid) {
        advantagesGrid.style.transform = '';
        advantagesGrid.style.transition = '';
        const oldClones = advantagesGrid.querySelectorAll('.advantage-card-clone');
        oldClones.forEach(clone => clone.remove());
      }
      return;
    }

    containerAdvange = document.querySelector('.container_advange');
    advantagesGrid = document.querySelector('.advantages_grid');
    
    if (!containerAdvange || !advantagesGrid) return;

    const realItems = getRealAdvantageItems();
    if (realItems.length === 0) return;

    // Клонируем элементы для бесконечной карусели
    cloneAdvantageItems();
    
    // Устанавливаем начальную позицию
    currentAdvantageIndex = 0;
    advantagesGrid.style.transition = 'none';
    advantagesGrid.style.transform = `translateX(${getInitialAdvantageTranslate()}px)`;
    
    // Применяем transition и устанавливаем правильную позицию
    setTimeout(() => {
      advantagesGrid.style.transition = `transform ${getAdvantageTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      updateAdvantagesSlider();
    }, 50);

    // Обработчики для мыши
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;

    advantagesGrid.addEventListener('mousedown', (e) => {
      if (isAdvantageTransitioning || isAdvantageAnimating || window.innerWidth > 768) return;
      isDragging = true;
      startX = e.clientX;
      // Получаем текущую позицию из transform
      const currentTransform = advantagesGrid.style.transform;
      const match = currentTransform.match(/translateX\(([^)]+)\)/);
      initialTranslate = match ? parseFloat(match[1]) : getInitialAdvantageTranslate();
      advantagesGrid.classList.add('dragging');
      e.preventDefault();
    });

    advantagesGrid.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      advantagesGrid.style.transform = `translateX(${initialTranslate + currentX}px)`;
    });

    advantagesGrid.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      advantagesGrid.classList.remove('dragging');

      const threshold = getAdvantageItemStep() / 6;
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevAdvantage();
        } else {
          goToNextAdvantage();
        }
      } else {
        updateAdvantagesSlider();
      }
      currentX = 0;
    });

    advantagesGrid.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        advantagesGrid.classList.remove('dragging');
        updateAdvantagesSlider();
        currentX = 0;
      }
    });

    // Обработчики для touch
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    advantagesGrid.addEventListener("touchstart", (e) => {
      if (isAdvantageTransitioning || isAdvantageAnimating || window.innerWidth > 768) return;
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      // Получаем текущую позицию из transform
      const currentTransform = advantagesGrid.style.transform;
      const match = currentTransform.match(/translateX\(([^)]+)\)/);
      touchInitialTranslate = match ? parseFloat(match[1]) : getInitialAdvantageTranslate();
      advantagesGrid.classList.add('dragging');
    });

    advantagesGrid.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;
      
      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }
      
      if (window.innerWidth <= 768) {
        advantagesGrid.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
      }
    });

    advantagesGrid.addEventListener("touchend", () => {
      if (!isDragging) return;
      isDragging = false;
      advantagesGrid.classList.remove('dragging');
      
      const threshold = getAdvantageItemStep() / 6;
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevAdvantage();
        } else {
          goToNextAdvantage();
        }
      } else {
        updateAdvantagesSlider();
      }
      touchCurrentX = 0;
    });

    // Обновление при изменении размера окна
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth <= 768) {
          cloneAdvantageItems();
          currentAdvantageIndex = 0;
          updateAdvantagesSlider();
        } else {
          // На десктопе возвращаем обычный grid
          const oldClones = advantagesGrid.querySelectorAll(".advantage-card-clone");
          oldClones.forEach(clone => clone.remove());
          advantagesGrid.style.transform = '';
          advantagesGrid.style.transition = '';
          currentAdvantageIndex = 0;
        }
      }, 100);
    });
  }

  // Инициализация при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initAdvantagesSlider, 300);
    });
  } else {
    setTimeout(initAdvantagesSlider, 300);
  }

  // Переинициализация при загрузке страницы
  window.addEventListener('load', () => {
    if (window.innerWidth <= 768) {
      currentAdvantageIndex = 0;
      updateAdvantagesSlider();
    }
  });

  // Публичная функция для переинициализации слайдера
  window.reinitAdvantagesSlider = function() {
    if (window.innerWidth <= 768 && advantagesGrid && containerAdvange) {
      const realItems = getRealAdvantageItems();
      if (realItems.length > 0) {
        cloneAdvantageItems();
        currentAdvantageIndex = 0;
        updateAdvantagesSlider();
      }
    }
  };
})();

